import React from 'react';
import './index.css'

export default function Loadingpage() {
    return (<div >
        <section className='main'>
            <div class="loading">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <img className="smallworldailogo" src="./images/logolight_smallworld.png"></img>
        </section>
    </div >)
}
